// Configuration des sections pour chaque page Espace Pro
// Utilisé pour la navigation intra-page (mobile: menu sticky, desktop: dropdown)

import { 
  Lightbulb, Store, Users, Rocket, Globe, BarChart3, 
  Crown, Zap, MessageSquare, Shield, CreditCard, Clock,
  Target, Briefcase, Bot, Sparkles, CheckCircle, Layout,
  PieChart, FileText, Heart, Star, Award, Gift, Package,
  Mic, HardHat, TrendingUp, Settings, Building2, Headphones
} from 'lucide-react';

// ═══════════════════════════════════════════════════════════════════════════════
// SECTIONS PAR PAGE
// ═══════════════════════════════════════════════════════════════════════════════

export const ESPACE_PRO_SECTIONS = {
  // Page Présentation (/pro)
  '/pro': {
    label: 'Présentation',
    sections: [
      { id: 'hero', label: 'Accueil', icon: Sparkles },
      { id: 'ecosysteme', label: 'Écosystème', icon: Layout },
      { id: 'assistant', label: 'Assistant', icon: Bot },
      { id: 'boutique', label: 'Boutique', icon: Store },
      { id: 'fondateur', label: 'Fondateur', icon: Crown },
    ]
  },

  // Page Boutique (/pro/boutique)
  '/pro/boutique': {
    label: 'Boutique',
    sections: [
      { id: 'hero', label: 'Ta boutique', icon: Store },
      { id: 'concept', label: 'Le concept', icon: Lightbulb },
      { id: 'features', label: 'Inclus', icon: CheckCircle },
      { id: 'equipe-ia', label: 'Équipe IA', icon: Bot },
      { id: 'installation', label: 'Installation', icon: Clock },
      { id: 'domaine-inclus', label: 'Domaine', icon: Globe },
      { id: 'offres', label: 'Formules', icon: CreditCard },
      { id: 'cle-en-main', label: 'Service clé en main', icon: Gift },
    ]
  },

  // Page Cockpit Bâtiment (/pro/crm-batiment)
  '/pro/crm-batiment': {
    label: 'Cockpit Bâtiment',
    sections: [
      { id: 'hero', label: 'Le Cockpit', icon: Briefcase },
      { id: 'features', label: 'Fonctionnalités', icon: CheckCircle },
      { id: 'collaboration', label: 'Collaboration', icon: Users },
      { id: 'system', label: 'Système', icon: Settings },
      { id: 'voice', label: 'Vocal', icon: Mic },
      { id: 'portal', label: 'Portail client', icon: Globe },
      { id: 'couts-marges', label: 'Coûts & Marges', icon: TrendingUp },
      { id: 'automation', label: 'Automatisation', icon: Zap },
      { id: 'closing', label: 'Commencer', icon: Rocket },
    ]
  },

  // Page Super Assistant (/pro/super-assistant)
  '/pro/super-assistant': {
    label: 'Super Assistant',
    sections: [
      { id: 'hero', label: 'L\'assistant', icon: Bot },
      { id: 'benefices-artisan', label: 'Pour l\'artisan', icon: HardHat },
      { id: 'benefices-patron', label: 'Pour le patron', icon: Briefcase },
      { id: 'capacites', label: 'Capacités', icon: Zap },
      { id: 'comparaison', label: 'Comparatif', icon: PieChart },
      { id: 'cta', label: 'Commencer', icon: Rocket },
    ]
  },

  // Page Équipe Agents IA (/pro/equipe-agents-ia)
  '/pro/equipe-agents-ia': {
    label: 'Équipe Agents IA',
    sections: [
      { id: 'hero', label: 'L\'équipe', icon: Users },
      { id: 'gains', label: 'Ce que tu gagnes', icon: Target },
      { id: 'experts', label: 'Les 12 experts', icon: Award },
      { id: 'scenarios', label: 'Dream Team', icon: Heart },
      { id: 'comparatif', label: 'Comparatif', icon: PieChart },
      { id: 'fondateur', label: 'Commencer', icon: Rocket },
    ]
  },

  // Page Tarifs (/pro/tarifs)
  '/pro/tarifs': {
    label: 'Tarifs',
    sections: [
      { id: 'hero', label: 'Accueil', icon: CreditCard },
      { id: 'offres', label: 'Nos offres', icon: Package },
      { id: 'comparatif', label: 'Comparatif', icon: BarChart3 },
      { id: 'avantages', label: 'Avantages', icon: CheckCircle },
      { id: 'faq', label: 'Commencer', icon: Rocket },
    ]
  },

  // Page Membre Fondateur (/pro/fondateur)
  '/pro/fondateur': {
    label: 'Membre Fondateur',
    sections: [
      { id: 'hero', label: 'Devenir Fondateur', icon: Crown },
      { id: 'service', label: 'Clé en main', icon: Gift },
      { id: 'avantages', label: 'Avantages', icon: Star },
      { id: 'offres', label: 'Formules', icon: CreditCard },
      { id: 'confiance', label: 'Confiance', icon: Shield },
      { id: 'inscription', label: 'S\'inscrire', icon: Rocket },
    ]
  },
};

// Helper: récupérer les sections pour une route donnée
export const getSectionsForRoute = (pathname) => {
  // Correspondance exacte d'abord
  if (ESPACE_PRO_SECTIONS[pathname]) {
    return ESPACE_PRO_SECTIONS[pathname];
  }
  
  // Sinon, chercher une correspondance partielle
  const routes = Object.keys(ESPACE_PRO_SECTIONS);
  for (const route of routes) {
    if (pathname.startsWith(route) && route !== '/pro') {
      return ESPACE_PRO_SECTIONS[route];
    }
  }
  
  // Fallback sur la page présentation
  if (pathname.startsWith('/pro')) {
    return ESPACE_PRO_SECTIONS['/pro'];
  }
  
  return null;
};

// Helper: vérifier si une route est une page Espace Pro
export const isEspaceProRoute = (pathname) => {
  return pathname.startsWith('/pro');
};
